import { makeStyles } from '@material-ui/styles';

export const useStyle = makeStyles(() => ({
    inputRoot: {
        borderRadius: '8px',
        overflow: 'hidden',

        '&:not(hover):not($disabled):not($cssFocused):not($error) $notchedOutline': {
            border: '1px solid #DDDDDD',
        },
        '&$cssFocused $notchedOutline': {
            border: '1px solid #0B9AD8',
        },
        '&$error $notchedOutline': {
            border: '1px solid #D92D20',
        },
        '&$disabled $notchedOutline': {
            border: '1px solid #dddddd',
        },
    },
    inputField: {
        fontFamily: 'var(--fontFamily)',
        padding: '10px 16px',
        fontSize: '16px',
        '&::placeholder': {
            fontSize: '16px',
            color: '#98A2B3',
        },
    },
    notchedOutline: {},
    error: {},
    focused: {},
    disabled: {
        backgroundColor: '#f2f4f7',
    },
    helperTextRoot: {
        letterSpacing: 0,
        '&.Mui-error': {
            color: '#D92D20',
        },
    },
    helperTextContained: {
        margin: '0px',
    },
    helperText: {
        marginTop: '6px',
        fontFamily: 'var(--fontFamily)',
        fontSize: '14px',
        fontWeight: 400,
        color: '#D92D20',
    },
    adornmentIcon: {
        height: '20px',
        width: '20px',
        cursor: 'pointer',
    },
}));
